<template>
	<div>
		<case-form :schema="schema" />
	</div>
</template>

<script>
import CaseForm from "../../CaseForm/CaseForm.vue"

export default {
	name: "CBProposalKeysAndSpecialProtectionMeans",
	components: { CaseForm },
	data() {
		return {
			schema: [
				{
					label:
						"15. Are all the keys (including your Alarm, Safe and Strong Room keys) removed from the premises outside business hours?",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: "case.facts.insured0KeyRemovedOutsideBusinessHoursId",
					props: {
						suggest: {
							typeIncludes: "keyRemovedOutsideBusinessHours"
						},
						createOptions: {
							type: "keyRemovedOutsideBusinessHours",
							dataType: "string"
						}
					}
				},
				{
					label:
						"16. Are there any other special means of protection? If so, give details.",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: "case.facts.insured0SpecialProtectionDetailsId",
					props: {
						suggest: {
							typeIncludes: "specialProtectionDetails"
						},
						createOptions: {
							type: "specialProtectionDetails",
							dataType: "string"
						}
					}
				}
			]
		}
	}
}
</script>
